/**
 * pc-article-seo-sidebar-card.js
 * Finds the first keyword-matched product from blog-seo-product-cards.json
 * and renders a compact product card in the sidebar (below TOC).
 */
(function () {
  'use strict';

  var container = document.querySelector('[data-bind="sidebar"] [data-bind="sidebar-product"]');
  if (!container) return;

  var root = document.getElementById('blog-article-body');
  if (!root || root.getAttribute('data-blog-seo-inline-cards') !== 'true') return;

  var jsonUrl = window.__BLOG_SEO_PRODUCT_CARDS_JSON__;
  if (!jsonUrl) return;

  function escapeRegex(s) {
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function firstMatchIndex(text, matchKeyword, excludePhrases) {
    var kw = String(matchKeyword || '').trim();
    if (!kw) return -1;
    var lowerKw = kw.toLowerCase();
    var suffixes = [];
    var exList = excludePhrases || [];
    for (var i = 0; i < exList.length; i++) {
      var ex = String(exList[i] || '').trim();
      if (!ex) continue;
      if (ex.toLowerCase().indexOf(lowerKw) !== 0) continue;
      var suffix = ex.slice(kw.length);
      if (suffix) suffixes.push(escapeRegex(suffix));
    }
    var lookahead = suffixes.length ? '(?!' + suffixes.join('|') + ')' : '';
    var re = new RegExp('\\b' + escapeRegex(kw) + lookahead + '\\b', 'i');
    var m = re.exec(text);
    return m ? m.index : -1;
  }

  function paragraphMatchIndex(p, cfg) {
    var text = p.textContent || '';
    if (cfg.match != null && String(cfg.match).trim() !== '') {
      return firstMatchIndex(text, cfg.match, cfg.excludePhrases);
    }
    var keywords = cfg.keywords;
    if (!keywords || !keywords.length) return -1;
    var lower = text.toLowerCase();
    var best = -1;
    for (var i = 0; i < keywords.length; i++) {
      var kw = String(keywords[i] || '').trim().toLowerCase();
      if (!kw) continue;
      var idx = lower.indexOf(kw);
      if (idx !== -1 && (best === -1 || idx < best)) best = idx;
    }
    return best;
  }

  function formatMoneyCents(cents) {
    var n = Number(cents);
    if (Number.isNaN(n)) return '';
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(n);
    }
    return '$' + (n / 100).toFixed(2);
  }

  function normalizeImageSrc(entry) {
    if (!entry) return '';
    if (typeof entry === 'string') {
      return entry.indexOf('//') === 0 ? 'https:' + entry : entry;
    }
    var src = entry.src || entry.url || '';
    if (!src) return '';
    return src.indexOf('//') === 0 ? 'https:' + src : src;
  }

  function getImageUrl(product) {
    if (product.images && product.images.length) return normalizeImageSrc(product.images[0]);
    if (product.featured_image) return normalizeImageSrc(product.featured_image);
    return '';
  }

  function firstAvailableVariant(product) {
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) return variants[i];
    }
    return variants[0] || null;
  }

  function escapeHtml(s) {
    if (s == null || s === '') return '';
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function productUrl(product) {
    var u = product && product.url ? String(product.url) : '';
    if (!u) return '/';
    if (u.indexOf('http') === 0) return u;
    try { return new URL(u, window.location.origin).href; } catch (e) { return u; }
  }

  function renderCard(cfg, product) {
    var variant = firstAvailableVariant(product);
    var priceCents = variant && variant.price != null ? variant.price : product.price;
    var priceText = formatMoneyCents(priceCents);
    var href = productUrl(product);
    var title = escapeHtml(cfg.title || product.title || '');
    var subtitle = escapeHtml(cfg.subtitle || '');
    var imgSrc = getImageUrl(product);

    var html =
      '<a data-bind="url" href="' + href + '">' +
        (imgSrc ? '<img src="' + imgSrc + '" alt="' + title + '" width="400" height="400" loading="lazy">' : '') +
      '</a>' +
      '<div data-bind="sidebar-product-main">' +
        '<h4 data-bind="title">' + title + '</h4>' +
        (subtitle ? '<p data-bind="subtitle">' + subtitle + '</p>' : '') +
        '<div data-bind="bottom">' +
          '<span data-bind="price">' + priceText + '</span>' +
          '<a data-bind="cta" href="' + href + '" aria-label="Shop ' + title + '">' +
            '<i class="bi bi-cart"></i>' +
          '</a>' +
        '</div>' +
      '</div>';

    container.innerHTML = html;
    container.style.display = '';
  }

  async function run() {
    var blogHandle = (root.getAttribute('data-blog-seo-blog-handle') || '').trim().toLowerCase();
    var sectionHandlesRaw = root.getAttribute('data-blog-seo-allowed-blog-handles') || '';
    var sectionBlogHandles = sectionHandlesRaw.split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);

    var res = await fetch(jsonUrl);
    if (!res.ok) return;
    var data = await res.json();
    var cards = data.cards || data;
    if (!Array.isArray(cards)) return;

    var effectiveBlogHandles = sectionBlogHandles.length ? sectionBlogHandles :
      (Array.isArray(data.allowedBlogHandles) ? data.allowedBlogHandles.map(function (h) { return String(h || '').trim().toLowerCase(); }).filter(Boolean) : []);

    if (effectiveBlogHandles.length && (!blogHandle || effectiveBlogHandles.indexOf(blogHandle) === -1)) return;

    var paragraphs = Array.prototype.slice.call(root.querySelectorAll('p'));
    var matchedCfg = null;

    for (var pi = 0; pi < paragraphs.length && !matchedCfg; pi++) {
      var p = paragraphs[pi];
      for (var ci = 0; ci < cards.length; ci++) {
        var cfg = cards[ci];
        if (!cfg || !cfg.handle) continue;
        var hasMatchRule = (cfg.match != null && String(cfg.match).trim() !== '') || (cfg.keywords && cfg.keywords.length);
        if (!hasMatchRule) continue;
        if (paragraphMatchIndex(p, cfg) !== -1) {
          matchedCfg = cfg;
          break;
        }
      }
    }

    if (!matchedCfg) return;

    try {
      var prodRes = await fetch('/products/' + encodeURIComponent(matchedCfg.handle) + '.js');
      if (!prodRes.ok) return;
      var product = await prodRes.json();
      renderCard(matchedCfg, product);
    } catch (e) { /* silent */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
